import { ReactElement } from 'react';

export const Empty = (): ReactElement => (
  <i style={{ opacity: 0.5 }}>&ndash;</i>
);
